import { Injectable } from "@angular/core";
import { Subscription, Observable, Subject, timer } from "rxjs";
import { AuthenticationService } from "../auth";

@Injectable({
  providedIn: 'root'
})
export class TimersService {

  private _count = 0;
  private _timeoutMillisecondSession = 1000 * 60 * 50;
  private _timeoutMillisecondToken = 1000 * 60 * 60;// colocar el tiempo de duracion de la sesion.
  private timerSubscription: Subscription = new Subscription;
  private timerSubscriptionToken: Subscription = new Subscription;
  private _timer: Observable<number> = new Observable;
  private resetOnTrigger: Boolean = false;
  public timeoutExpired: Subject<number> = new Subject<number>();

  acction =false;

  constructor(
    private readonly authenticationService: AuthenticationService,
  ) {
    this.timeoutExpired.subscribe(n => {
      console.log('timeoutExpired subject next.. ' + n.toString());
    });

  }


  async resetTimmer() {
    // console.log('resetTimer');
    const curus = this.authenticationService.currentUserValue;
    // console.log('curus',curus);

    if (curus !=null) {
      this.acction=true
      // console.log('tengoToken');
      this.startTimer();
    } else {
      // console.log('notengoToken');
    }
  }

  private setSubscription() { // timer de accion sobre ventana se reinica cada vez que existe accion
    this._timer = timer(this._timeoutMillisecondSession);
    this.timerSubscription = this._timer.subscribe(n => {
      this.timerComplete(n);
    });
  }

  setSubscriptionToken(){ //timer de token se setea al ingresar
    this._timer = timer(this._timeoutMillisecondToken);
    this.timerSubscriptionToken = this._timer.subscribe(n => {
      this.timerCompleteToken(n);
    });
  }

  //  startDateCompare() {
  //   this.lastTime = (new Date()).getTime();
  //   this.dateTimer = timer(this.dateTimerInterval); // compare every five minutes
  //   this.dateTimerSubscription = this.dateTimer.subscribe(n => {
  //     const currentTime: number = (new Date()).getTime();
  //     const time = this.lastTime + this.dateTimerInterval + this.dateTimerTolerance;
  //     console.log('this.lastTime + this.dateTimerInterval + this.dateTimerTolerance', time);
  //     console.log('currentTime', currentTime);
  //     console.log('time', time);
  //     console.log('currentTime - time', currentTime - time );
  //     if (currentTime > time) { // look for 10 sec diff
  //       console.log('Looks like the machine just woke up.. ');
  //     }  else {
  //       console.log('Machine did not sleep.. ');
  //     }
  //     this.dateTimerSubscription.unsubscribe();
  //     // this.startDateCompare();
  //   });
  // }

  public startTimerToken() {
    if (this.timerSubscriptionToken) {
      this.stopTimerToken();
    }
    this.setSubscriptionToken();
  }


  public startTimer() {
    if (this.timerSubscription) {
      this.stopTimer();
    }
    this.setSubscription();
  }


  public stopTimer() {
    this.timerSubscription.unsubscribe();
  }

  public stopTimerToken() {
    this.timerSubscriptionToken.unsubscribe();
  }

  public resetTimer() {
    this.startTimer();
  }

  public forcedTimeout(){
    this.timeoutExpired.next(2400000);
  }

  public timerComplete(n: number) {
    this.acction=false;
    this.timeoutExpired.next(++this._count);


    if (this.resetOnTrigger) {
      this.startTimer();
    }
  }

  public timerCompleteToken(n: number) {
    if(this.acction){
      console.log('refresh');
    //  this.authenticationService.refreshToken();
    }
  }
}